module.exports = __webpack_public_path__ + "img/background-6.64fe7882.jpg";